import * as yup from "yup";

export const updateTermsValidation = yup.object().shape({
    text: yup.string().required('Campo "Termo de Privacidade" é obrigatório'),
    }
)